import { render, staticRenderFns } from "./operator-logistics.vue?vue&type=template&id=214aaca3&"
import script from "./operator-logistics.vue?vue&type=script&lang=js&"
export * from "./operator-logistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports